// https://www.npmjs.com/package/react-scroll
import { Link } from "react-scroll";
// https://react-icons.github.io/react-icons/
import { FaChevronCircleDown } from "react-icons/fa";
import NavBar from "../containers/NavBar";
import SocialLinks from "./SocialLinks";
import { FaPhoneAlt,FaDownload } from "react-icons/fa";
import { GrMail,GrView } from "react-icons/gr";

// Image
import logo from "../images/logo.svg";

const About = ({ theme, setTheme, githubUrl, name, link, bio, twitter }) => {
  const newTheme = `${theme} d-flex flex-column min-vh-100 justify-content-center`;

  const socialData = {
    githubUrl: githubUrl,
    link: link,
    twitter: twitter,
  };
  const viewResume = 'https://drive.google.com/file/d/1vgIv__5niuu5ACjeIzYTHHnkmg1zKgFs/view?usp=sharing';
  const downloadResume='https://drive.google.com/uc?export=download&id=1vgIv__5niuu5ACjeIzYTHHnkmg1zKgFs';

  return (
    <header id="about" className={newTheme}>
      <NavBar theme={theme} setTheme={setTheme} />
      <div className="container text-center mt-5">
        {/* <img
          className="logo spin img-fluid"
          src={logo}
          alt="React Logo"
          height="45%"
          width="45%"
        /> */}
        <h1>I'm {name}</h1>
        <hr />
        <p>Javascript (MERN stack) Developer | Machine Learning Enthusiast | Competetive Programmer | Tech Lover</p>
        <p><GrMail /> abusaid.rezoun@gmail.com</p>
        <p><FaPhoneAlt /> +8801788210077</p>
        <SocialLinks {...socialData} />

        {/* download buttons */}
        <div className="mt-2">
        <a href={viewResume} target="_blank" rel="noreferrer">
        <button type="button" style={{backgroundColor:'tomato',color:'white'}} className=" my-1 btn btn-lg"><GrView/> View Resume</button>
        </a>
        <a href={downloadResume} target="_blank" rel="noreferrer">
        <button type="button" style={{backgroundColor:'tomato',color:'white'}} className=" mx-2 my-1 btn btn-lg"><FaDownload/> Download Resume</button>
        </a>
        </div>
        <Link className="scroll" to="skills" smooth={true} duration={750}>
          <FaChevronCircleDown id="scroll-down" />
        </Link>
      </div>
    </header>
  );
};

export default About;
